import React, { useState } from "react";
import api, { API, formatApiError } from "@/lib/api";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export function imageUrl(path) {
  if (!path) return null;
  return `${API}/files/image?path=${encodeURIComponent(path)}`;
}

export default function ImageUploader({ kind, itemId, value, onUploaded, className = "" }) {
  const [busy, setBusy] = useState(false);

  const handle = async (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files allowed");
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/${kind}/${itemId}/image`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onUploaded?.(data.image_path);
      toast.success("Image uploaded");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`relative ${className}`}>
      {value ? (
        <div className="relative w-full h-full">
          <img src={imageUrl(value)} alt="" className="w-full h-full object-cover rounded-xl" />
          <label className="absolute bottom-2 right-2 cursor-pointer">
            <span className="pill-btn bg-hearth-ink/85 text-white inline-flex items-center gap-1.5 text-xs">
              <Upload size={12} /> Replace
            </span>
            <input type="file" hidden accept="image/*" onChange={(e) => { handle(e.target.files?.[0]); e.target.value = ""; }} />
          </label>
        </div>
      ) : (
        <label className="cursor-pointer w-full h-full flex flex-col items-center justify-center gap-2 border border-dashed border-hearth-line rounded-xl bg-hearth-stone/40 hover:bg-hearth-stone/70 transition py-6">
          {busy ? <Loader2 size={18} className="animate-spin text-hearth-clay" /> : <Upload size={18} className="text-hearth-clay" />}
          <span className="caption text-hearth-mute">{busy ? "Uploading…" : "Add a photo"}</span>
          <input type="file" hidden accept="image/*" onChange={(e) => { handle(e.target.files?.[0]); e.target.value = ""; }} />
        </label>
      )}
    </div>
  );
}
